<template>
  <div class="activeIntroduce">
    <div v-html="introduceHtml"></div>
  </div>
</template>

<script>
import {geteventSignInfo} from '@/api'
export default {
  data() {
    return {
      introduceHtml: ''
    }
  },
  mounted() {
    this.getActiveInfo()
  },
  components: {},

  methods: {
    getActiveInfo() {
      const params = {
        eventSignId: this.$route.query.id,
        forType: 5
      }
      geteventSignInfo(params).then(res => {
        if (res.success) {
          this.introduceHtml = res.data.eventDesc
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.activeIntroduce {
  width: 100%;
  min-height: calc(100vh - 210px);
  background-color: #fff;
  padding: 16px;
  ::v-deep img {
    max-width: 100% !important;
    height: auto !important;
  }
}
</style>
